module.exports = __webpack_public_path__ + "img/icon-download.35f97ed5.svg";